/**
 * Created by ivan on 16.04.18.
 */

const BlastAnimation = BaseAnimation.extend({
    ctor: function (skin) {
        this._super(bundles.burst.jsons.burst_blast_json);
        if (this.animation) {
            this.animation.setSkin(skin);
        }
    }
});

BlastAnimation.factory = function (skin) {
    return cleverapps.pool.hasObject(BlastAnimations[skin]) ? cleverapps.pool.getFromPool(BlastAnimations[skin]) : new BlastAnimations[skin]();
};

const BlastAnimations = {
    purple: BlastAnimation.extend({
        ctor: function () {
            this._super("purple"); 
        } 
    }),
    yellow: BlastAnimation.extend({
        ctor: function () {
            this._super("yellow"); 
        } 
    }),
    red: BlastAnimation.extend({
        ctor: function () {
            this._super("red"); 
        } 
    }),
    green: BlastAnimation.extend({
        ctor: function () {
            this._super("green"); 
        } 
    }),
    blue: BlastAnimation.extend({
        ctor: function () {
            this._super("blue"); 
        } 
    })
};